/** Default timeout in milliseconds for flushing pending analytics events to transport. */
export const FLUSH_DEFAULT_TIMEOUT_MS = 3000;

/** Maximum pending commands; the oldest is dropped at capacity. */
export const QUEUE_MAX_DEPTH = 50;

/** Maximum queue age in milliseconds before a command is dropped. */
export const QUEUE_MAX_AGE_MS = 15000;

/** Default post-track settle delay in milliseconds. */
export const DEFAULT_SETTLE_DELAY_MS = 25;

/** Maximum number of event log entries to retain for debugging and diagnostic purposes. */
export const EVENT_LOG_ENTRIES_CAPACITY = 100;

/** Timeout before pending commands are dropped while transport readiness is unavailable. */
export const READINESS_TIMEOUT_MS = 10000;

/** Maximum number of analytics events allowed in the deferred queue for later processing. */
export const DEFERRED_QUEUE_MAX = 50;
